<template>
  <div class="animated fadeIn"><router-view></router-view></div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Statistics'
};
</script>

<style lang="scss">
.statistics {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.dashboard-item {
}

.statistics-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  color: #bcc5d0;
}

.statistics-link.active {
  color: #167495;
}
.statistics_img {
  width: 40px;
  opacity: 0.5;
}

.statistics-link.active .statistics_img {
  opacity: 1;
}
</style>
